import vtkStateBuilder from 'vtk.js/Sources/Widgets/Core/StateBuilder';
import Constants from 'vtk.js/Sources/Widgets/Widgets3D/LineWidget/Constants';

const { ShapeType } = Constants;

//The majority of this code is copied from the LineWidget state file
// https://github.com/Kitware/vtk-js/tree/05d7cf7c3b0f853fc67f7bdc1c1c35032584486c/Sources/Widgets/Widgets3D/LineWidget/state.js

// make line position a sub-state so we can listen to it
// separately from the rest of the widget state.

const linePosState = vtkStateBuilder
    .createBuilder()
    .addField({
        name: 'posOnLine',
        initialValue: 0.5,
    })
    .build();

const handleShape = ShapeType.SPHERE;
const handleScale = 30;

export default function generateState(addedMeasurementCallback) {
    const state =
        vtkStateBuilder
        .createBuilder()
        .addStateFromMixin({
            labels: ['moveHandle'],
            mixins: ['origin', 'color', 'scale1', 'visible', 'manipulator', 'shape'],
            name: 'moveHandle',
            initialValues: {
                scale1: handleScale,
                visible: true,
                shape: handleShape
            },
        })
        .addStateFromMixin({
            labels: ['handle1'],
            mixins: ['origin', 'color', 'scale1', 'visible', 'manipulator', 'shape'],
            name: 'handle1',
            initialValues: {
                scale1: handleScale,
                visible: true,
                shape: handleShape
            },
        })
        .addStateFromMixin({
            labels: ['handle2'],
            mixins: ['origin', 'color', 'scale1', 'visible', 'manipulator', 'shape'],
            name: 'handle2',
            initialValues: {
                scale1: handleScale,
                visible: true,
                shape: handleShape
            },
        })
        .addStateFromMixin({
            labels: ['svgText'],
            mixins: ['origin', 'color', 'text', 'visible'],
            name: 'text',
            initialValues: {
                /* text is empty to set a text filed in the SVGLayer and to avoid
                 * displaying text before positioning the handles */
                text: '',
            },
        })
        .addStateFromInstance({ name: 'positionOnLine', instance: linePosState })
            .addField({ name: 'lineThickness' })
            .addField({ name: 'unitConversionFactor', initialValue: 1.0 })
            .addField({ name: 'addedMeasurementCallback', initialValue: addedMeasurementCallback })
            .build();

    return state;
}